import { combineReducers } from 'redux';

import * as types from 'modules/campaigns/actionTypes';
import { CREATION_MODAL_SOURCE } from 'modules/campaigns/constants';
import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  creating: boolean,
 * }} CampaignUIModalCreationReducer
 */

export default combineReducers({
  open: createReducer(false, {
    [types.OPEN_MODAL_CREATION]: () => true,
    [types.CLOSE_MODAL_CREATION]: () => false,
    [types.CREATE_CAMPAIGN_SUCCESS]: () => false,
  }),
  creating: loading(types.CREATE_CAMPAIGN, { global: { matcher: ({ meta }) => meta.source === CREATION_MODAL_SOURCE } })
});
